import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, Row } from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const UiCompAdmin_NewUiCompView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [uiCompAttrs, setUiCompAttrs] = useState({
    name: '',
    type: '',
    typeId: '',
    description: '',
    config: '',
    dataList: ''
  });


/*
  const chartTypeList = [
    { key: "LINE_CHART", value: "LINE_CHART" },
    { key: "BAR_CHART",  value: "BAR_CHART" },
    { key: "AREA_CHART", value: "AREA_CHART" }
  ];
*/

  // Ui Functions

  const [errMsg, setErrMsg] = useState('');

  const [uiCompTypeList, setUiCompTypeList] = useState([]);

  const [selectedCompType, setSelectedCompType] = useState({});
  const [typeSpecificAttrs, setTypeSpecificAttrs] = useState([]);

  const [dataObjList, setDataObjList] = useState([]);


  const fetchCompTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-comp-types");

        resolve(res.data);

        if (res.status === 200) {
          setUiCompTypeList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  // Initialize state
  useEffect(() => {
    fetchCompTypes();

    // Init data obj list
    let tmpList = [];
    for (let i=0; i<10; i++) {
      tmpList.push ({code: '',
                     name: '',
                     color: ''});
    }

    setDataObjList (tmpList);

    //initFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAttrsInputChange = (e) => {
    setUiCompAttrs({ ...uiCompAttrs, [e.target.name]: e.target.value })
  }

/*
  const onTypeSpecificAttrsInputChange = (e) => {
    setTypeSpecificAttrs({ ...typeSpecificAttrs, [e.target.name]: e.target.value })
  }

  const onChartTypeSelect = (key, event) => {
    setTypeSpecificAttrs({ ...typeSpecificAttrs, 'chartType': key })
  };

  const onDataObjInputChange = (index, e) => {
    let tmpList = JSON.parse(JSON.stringify(dataObjList));
    tmpList[index][e.target.name] = e.target.value;

    setDataObjList(tmpList);
  }
*/

/*
  const onCompTypeSelect = (key, event) => {
    setUiCompAttrs({ ...uiCompAttrs, typeId: key })

    let tmpCompType = uiCompTypeList.find( ({ id }) => id === parseInt(key) );
    let tmpArray = tmpCompType.attrList.split(',');
    let tmpAttrList = {}

    for (let i=0; i<tmpArray.length; i++) {
      tmpAttrList[tmpArray[i]] = '';
    }

    setSelectedCompType (tmpCompType);
    setTypeSpecificAttrs (tmpAttrList);
  };
*/
  const onCompTypeClick = (key, event) => {
    setUiCompAttrs({ ...uiCompAttrs, typeId: key })

    let tmpCompType = uiCompTypeList.find( ({ id }) => id === parseInt(key) );
    let tmpArray = tmpCompType.attrList.split(',');
    let tmpAttrList = {}

    for (let i=0; i<tmpArray.length; i++) {
      tmpAttrList[tmpArray[i]] = '';
    }

    setSelectedCompType (tmpCompType);
    setTypeSpecificAttrs (tmpAttrList);
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!uiCompAttrs.name || uiCompAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_comp_name"));
    } else if (uiCompAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + "100");
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-comps?name=" + uiCompAttrs.name);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_Dup_name"));
        } else {
          validateOtherFields();
        }

        return;
      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

/*
    if (!uiCompAttrs.description || uiCompAttrs.description === '') {
      setErrMsg(t("I18N_ERR_Need_description"));
*/
    if (uiCompAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "250");

    } else if (!uiCompAttrs.typeId) {
      setErrMsg(t("I18N_ERR_Need_uiComp_typeId"));

    } else {
      setErrMsg('');
      createNewUiComp();
    }
  }

  const createNewUiComp = () => {

    // Make a deep copy
    let reqBody = JSON.parse(JSON.stringify(uiCompAttrs));

    // Compose configuration attributes
    let tmpConfig = JSON.parse(JSON.stringify(typeSpecificAttrs));

    reqBody.config = JSON.stringify(tmpConfig);

    if (selectedCompType && (selectedCompType.dataSrcStyle === 'FIXED')) {

      let tmpDataList = [];

      for (let i=0; i<dataObjList.length; i++) {
        if (dataObjList[i].name && dataObjList[i].name !== '')
          tmpDataList.push(dataObjList[i]);
      }

      reqBody.dataList = JSON.stringify(tmpDataList);
    } else {
      reqBody.dataList = null;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("ui-comps", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


/*
  function renderTypeSpecificAttrs(attrName, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>
          <Row>
            <Col>{attrName}</Col>
            <Col>
              {attrName === 'chartType' ?
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={((!typeSpecificAttrs['chartType']) || (typeSpecificAttrs['chartType'] === "")) ? t("common:I18N_DROPDOWN_PROMPT") : typeSpecificAttrs['chartType']}
                  onSelect={onChartTypeSelect}>
                  {chartTypeList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                :
                <input className={classes.admin_pages__field_editable} name={attrName} value={typeSpecificAttrs[attrName]}
                  onChange={(e) => onTypeSpecificAttrsInputChange(e)} />
              }
            </Col>
            <Col></Col>
            <Col></Col>
          </Row>
        </td>
      </tr>
    )
  }


  function renderDataObj(dataObj, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>
          <Row>
            <Col>
              <input className={classes.admin_pages__field_editable} name='code' value={dataObj.code}
                onChange={(e) => onDataObjInputChange(index, e)} />
            </Col>
            <Col>
              <input className={classes.admin_pages__field_editable} name='name' value={dataObj.name}
                onChange={(e) => onDataObjInputChange(index, e)} />
            </Col>
            <Col>
              <input className={classes.admin_pages__field_editable} name='color' value={dataObj.color}
                onChange={(e) => onDataObjInputChange(index, e)} />
            </Col>
            <Col></Col>
          </Row>
        </td>
      </tr>
    )
  }
*/


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', height:'800px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_New_uiComp")}
          </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UiComp_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_UiComp_name")}: *</Col>
                <Col>{t("I18N_UiComp_type")}: *</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input className={classes.admin_pages__field_editable} name="name" value={uiCompAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
{/*
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                                  title={((!uiCompAttrs.typeId) || (uiCompAttrs.typeId.length === 0)) ? t("common:I18N_DROPDOWN_PROMPT") :
                                         (uiCompTypeList.find( ({ id }) => id === parseInt(uiCompAttrs.typeId) )).name}
                                  onSelect={onCompTypeSelect}>
                    {uiCompTypeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                          {item.name}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
*/}

                  <Dropdown>
                    <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                    {((!uiCompAttrs.typeId) || (uiCompAttrs.typeId.length === 0)) ? t("common:I18N_DROPDOWN_PROMPT") :
                                         (uiCompTypeList.find( ({ id }) => id === parseInt(uiCompAttrs.typeId) )).name}
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ maxHeight: "600px", overflowY: "auto"}} id="dropdown-basic-button" >
                      {uiCompTypeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onCompTypeClick(item.id)}>
                            {item.name}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={uiCompAttrs.description}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col></Col>
              </Row>
          </Container>

        </div>

{/* ##### FUTURE ENHANCEMENT - Can configure the UI compinent #####
        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Additional_attrs")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>

              <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

                <Table hover responsive size="sm">
                  <tbody>
                    {(Object.keys(typeSpecificAttrs)).map(renderTypeSpecificAttrs)}
                  </tbody>
                </Table>

              </div>
            </form>
          </Container>
        </div>

        { (selectedCompType && (selectedCompType.dataSrcStyle === 'FIXED')) ?

          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
            <div display='flex'>
              <span>
                {t("I18N_Data_selection")}
              </span>
            </div>
            <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

            <Container>
              <form>

                <Table hover responsive size="sm">
                  <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                    <tr>
                      <td>
                        <Row>
                          <Col><span style={{fontWeight:'400'}}>{t("I18N_Datapoint_code")}</span></Col>
                          <Col><span style={{fontWeight:'400'}}>{t("I18N_Display_name")}</span></Col>
                          <Col><span style={{fontWeight:'400'}}>{t("I18N_Color")}</span></Col>
                          <Col></Col>
                        </Row>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {dataObjList.map(renderDataObj)}
                  </tbody>
                </Table>

              </form>
            </Container>
          </div>
          :
          <></>
        }
*/}

        <hr className="solid" style={{ marginTop: '20px' }}></hr>

        <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
          <span>{t("I18N_Req_fields")}</span>
        </Row>

        <div display='flex' style={{marginTop:'15px'}}>
          <Button size="sm" variant="outline-secondary" className="mb-3"
            style={{ float: 'left' }}
            onClick={handleCancel}>
            {t("I18N_Cancel")}
          </Button>
          <Button size="sm" variant="outline-secondary" className="mb-3"
            style={{ marginLeft: '15px' }}
            onClick={handleSubmit}>
            {t("I18N_Submit")}
          </Button>
          <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
            {errMsg}
          </span>
        </div>

      </Card>
    </>
  );
}
 
export default UiCompAdmin_NewUiCompView;
